/**
 * ScoringModeToggle
 *
 * A small chip-style toggle placed in the scoreboard header that switches
 * between "Basic" and "Advanced" scoring modes.
 *
 * Props:
 *   mode          'basic' | 'advanced'
 *   onChange      (newMode: string) => void
 *   disabled      boolean
 *   sportSupported boolean  — if false we show a disabled tooltip
 */
import React from 'react';

const ScoringModeToggle = ({ mode = 'basic', onChange, disabled = false, sportSupported = true }) => {
  const isAdvanced = mode === 'advanced';

  const handleToggle = () => {
    if (disabled || !sportSupported) return;
    onChange(isAdvanced ? 'basic' : 'advanced');
  };

  const title = !sportSupported
    ? 'Advanced scoring is not available for this sport'
    : isAdvanced
      ? 'Switch to Basic scoring'
      : 'Switch to Advanced scoring (player + metric tracking)';

  return (
    <button
      className={`scoring-mode-toggle ${isAdvanced ? 'scoring-mode-toggle--advanced' : 'scoring-mode-toggle--basic'}`}
      onClick={handleToggle}
      disabled={disabled || !sportSupported}
      title={title}
      aria-label={title}
    >
      <span className="scoring-mode-toggle__icon">
        {isAdvanced ? '📊' : '⚡'}
      </span>
      <span className="scoring-mode-toggle__label">
        {isAdvanced ? 'Advanced' : 'Basic'}
      </span>
    </button>
  );
};

export default ScoringModeToggle;
